import React, { useState, useCallback, useEffect } from "react";
import classNames from "classnames";
import withHeaderItem from "utils/hoc/withHeaderItem";
import {
  Avatar,
  Dropdown,
  ScrollBar,
  Spinner,
  Badge,
  Button,
  Tooltip,
  Dialog,
} from "components/ui";
import { HiOutlineBell, HiOutlineMailOpen } from "react-icons/hi";
import {
  apiGetMyNotificationList,
  apiReadNotification,
} from "services/NotificationService";
import { Link } from "react-router-dom";
import isLastChild from "utils/isLastChild";
import useResponsive from "utils/hooks/useResponsive";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
const notificationHeight = "h-72";
export const Notification = ({ className }) => {
  const { t } = useTranslation();
  const [notificationList, setNotificationList] = useState([]);
  const [readMyNotification, setReadMyNotification] = useState({
    open: false,
    myNotification: {},
  });
  const [loading, setLoading] = useState(false);
  const { larger } = useResponsive();
  const { token } = useSelector((state) => state.auth?.session ?? {});
  const onNotificationOpen = useCallback(async () => {
    setLoading(true);
    let payload = {
      isread: "false",
      PageNumber: 1,
      PageSize: 100,
      ordercolumn: "notification.createdate",
      orderby: "1",
    };
    const resp = await apiGetMyNotificationList(payload);
    setLoading(false);
    setNotificationList(Array.isArray(resp?.data?.data) ? resp.data.data : []);
  }, [setLoading]);
  const onMarkAllAsRead = useCallback(async () => {
    if (notificationList.length > 0) {
      let payload = notificationList.map((item) => item.id);
      try {
        const success = await apiReadNotification(payload);
        if (success) {
          onNotificationOpen();
        }
      } catch (error) {
        return "Bir şeyler ters gitti!";
      }
    }
  }, [notificationList, onNotificationOpen]);
  const onMarkAsRead = useCallback(
    async (notification) => {
      try {
        const success = await apiReadNotification([notification.id]);
        if (success) {
          onNotificationOpen();
        }
      } catch (error) {
        return "Bir şeyler ters gitti!";
      }
      setReadMyNotification({
        open: true,
        myNotification: notification,
      });
    },
    [onNotificationOpen]
  );
  const NotificationToggle = ({ className, dot }) => {
    return (
      <div className={classNames("text-2xl", className)}>
        {dot ? (
          <Badge badgeStyle={{ top: "3px", right: "6px" }}>
            <HiOutlineBell />
          </Badge>
        ) : (
          <HiOutlineBell />
        )}
      </div>
    );
  };
  useEffect(() => {
    const getNotification = async () => {
      if (token) {
        let payload = {
          isread: "false",
          PageNumber: 1,
          PageSize: 100,
          ordercolumn: "notification.createdate",
          orderby: "1",
        };
        const resp = await apiGetMyNotificationList(payload);
        setNotificationList(Array.isArray(resp?.data?.data) ? resp.data.data : []);
      }
    };
    setTimeout(() => getNotification(), 1000);
  }, [token]);
  return (
    <>
      <Dropdown
        renderTitle={
          <NotificationToggle
            dot={notificationList.length !== 0}
            className={className}
          />
        }
        menuClass="p-0 min-w-[280px] md:min-w-[340px]"
        placement="bottom-end"
        onOpen={onNotificationOpen}
      >
        <Dropdown.Item variant="header">
          <div className="border-b border-gray-200 dark:border-gray-600 px-4 py-2 flex items-center justify-between">
            <h6>{t("header.notifications.title")}</h6>
            <Tooltip title={t("header.notifications.readAll") + "."}>
              <Button
                variant="plain"
                shape="circle"
                size="sm"
                icon={<HiOutlineMailOpen className="text-xl" />}
                onClick={onMarkAllAsRead}
              />
            </Tooltip>
          </div>
        </Dropdown.Item>
        <div className={classNames("overflow-y-auto", notificationHeight)}>
          <ScrollBar>
            {notificationList.length > 0 &&
              notificationList.map((item, index) => (
                <div
                  key={item.id}
                  className={`relative flex px-4 py-4 cursor-pointer hover:bg-gray-50 active:bg-gray-100 dark:hover:bg-black dark:hover:bg-opacity-20  ${
                    !isLastChild(notificationList, index)
                      ? "border-b border-gray-200 dark:border-gray-600"
                      : ""
                  }`}
                  onClick={() => onMarkAsRead(item)}
                >
                  <div>
                    <Avatar
                      shape="circle"
                      src={item.notification?.company?.logo}
                    />
                  </div>
                  <div className="ml-3">
                    <div>
                      <p className="whitespace-nowrap text-ellipsis overflow-hidden max-w-[250px]">
                        {item.notification?.message.replace(/<[^>]+>/g, "")}
                      </p>
                    </div>
                    <span className="text-xs">
                      {dayjs(item.notification?.createdate).format(
                        "DD/MM/YYYY"
                      )}
                    </span>
                  </div>
                  {/* <Badge
				className="absolute top-4 ltr:right-4 rtl:left-4 mt-1.5"
				innerClass={`${item.readed ? "bg-gray-300" : bgTheme} `}
			  /> */}
                </div>
              ))}
            {loading && (
              <div
                className={classNames(
                  "flex items-center justify-center",
                  notificationHeight
                )}
              >
                <Spinner size={40} />
              </div>
            )}
            {notificationList.length === 0 && (
              <div
                className={classNames(
                  "flex items-center justify-center",
                  notificationHeight
                )}
              >
                <div className="text-center">
                  <img
                    className="mx-auto mb-2 max-w-[150px]"
                    src="/img/others/no-notification.png"
                    alt="no-notification"
                  />
                  <h6 className="font-semibold">
                    {t("header.notifications.noNotifications")}.
                  </h6>
                </div>
              </div>
            )}
          </ScrollBar>
        </div>
        <Dropdown.Item variant="header">
          <div className="flex justify-center border-t border-gray-200 dark:border-gray-600 px-4 py-2">
            <Link
              to="/my-notifications"
              className="font-semibold cursor-pointer p-2 px-3 text-gray-600 hover:text-gray-900 dark:text-gray-200 dark:hover:text-white"
            >
              {t("header.notifications.allNotifications")}
            </Link>
          </div>
        </Dropdown.Item>
      </Dropdown>
      <Dialog
        closable={false}
        title=""
        isOpen={readMyNotification.open}
        onClose={() =>
          setReadMyNotification({
            ...readMyNotification,
            open: false,
          })
        }
        onRequestClose={() =>
          setReadMyNotification({
            ...readMyNotification,
            open: false,
          })
        }
      >
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2.5">
            <span className="flex items-center gap-2.5">
              <Avatar
                src={
                  readMyNotification.myNotification?.notification?.company?.logo
                }
                size={24}
                shape="circle"
              />
              <span className="capitalize font-bold">
                {readMyNotification.myNotification?.notification?.company?.name}
              </span>
            </span>
            {readMyNotification.myNotification?.notification?.branch && (
              <span>
                {readMyNotification.myNotification?.notification?.branch?.name}
              </span>
            )}
          </div>
          <span className="font-semibold">
            {dayjs(
              readMyNotification.myNotification?.notification?.createdate
            ).format("DD/MM/YYYY")}
          </span>
        </div>

        <div
          className="pt-5"
          dangerouslySetInnerHTML={{
            __html: readMyNotification.myNotification?.notification?.message,
          }}
        ></div>
        <div className="text-right mt-6">
          <span
            className="border py-2 px-3 rounded-md font-semibold cursor-pointer hover:bg-slate-50"
            variant="plain"
            onClick={() =>
              setReadMyNotification({
                ...readMyNotification,
                open: false,
              })
            }
          >
            {t("misc.close")}
          </span>
        </div>
      </Dialog>
    </>
  );
};

export default withHeaderItem(Notification);
